module.exports = __webpack_public_path__ + "static/img/Collection09@2x.de05513.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Collection09@2x.png
// module id = PaH8
// module chunks = 1